module.exports = __webpack_public_path__ + "img/02.ca9ffe0f.png";